import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiMethod } from '../../apimethods/api-method';
import * as ngswal from "sweetalert";
import { Testassignment } from './testassignmentmodel';
import { GlobalConstants } from '../../common/global-constants';
import { FreelancerlistComponent } from '../freelancerlist/freelancerlist.component';
import { localizedString } from '@angular/compiler/src/output/output_ast';
import { customfunctions } from "../../common/customfunctions";
declare var $;

@Component({
  selector: 'app-test-assignment',
  templateUrl: './test-assignment.component.html',
  styleUrls: ['./test-assignment.component.css']
})
/** TestAssignment component*/
export class TestAssignmentComponent implements OnInit {
  static modelItem = new Testassignment();
  static FreelancerID: any;
  static CategoryID: any;
  /** TestAssignment ctor */
  showpopupTestassign: boolean;
  static fileBase64: any;
  static file: any;
  articleList: any;
  minDate: string;
  ngOnInit(): void {
    ApiMethod.getBaseUrl();
    customfunctions.SetTodayDateValues("#Txt_FromDate");
    customfunctions.SetTodayDateValues("#Txt_ToDate");
    var today = new Date();
    
    this.minDate = today.toISOString().slice(0, 10);
  }

  constructor(private router: Router, private route: ActivatedRoute) {
    ApiMethod.getPageConfig().subscribe(
      data => {
        TestAssignmentComponent.modelItem = <Testassignment>data["FreelancerlistPage"];
        this.GetArticleList();
      },
      error => {
        ngswal("Warning !", error.message, "warning");
      });


  }

  public static AssignmentDetails(FreelancerID, CategoryID): void {
    this.FreelancerID = FreelancerID;
    this.CategoryID = CategoryID;
  }
  HideAssignment() {
    $('#TestassignPopup').hide();
    FreelancerlistComponent.Testassignhide();

  }
  //Get All ArticleNo list
  GetArticleList(): void {
    ApiMethod.getMethod(TestAssignmentComponent.modelItem.ArticleListAPI).subscribe(
      result => {
        this.articleList = result.aArticleList;

      }, error => {
        $("#LoadingImage").hide();
        ngswal("Warning !", error, "warning");
      });
  }
  GetArticleTitleList() {
    var artid = $("#ddlArticle").val();
    if (artid == null || artid == 0 || artid == "") {
      return false;
    }
    ApiMethod.getMethod(TestAssignmentComponent.modelItem.ArticleTitleAPI + artid).subscribe(
      result => {
        var aitem = result.aArticleList;
        $("#Txt_articleTitle").val(aitem[0].ArticleTitle);
      }, error => {
        $("#LoadingImage").hide();

      });
  }

  onuploadSelected(fileInput: any) {
    var allocate = $('#doc_testfile').val().split('.').pop().toLowerCase();
    var ext = $('#doc_testfile').val().split('.').pop().toLowerCase();
    //if ($.inArray(ext, ['doc', 'docx', 'pdf']) == -1) {
    //  $('#doc_testfile').val("");
    //  ngswal("Failed !", "Invalid File format", "warning");
    //  return false;
    //} else
    if (fileInput.target.files[0].size > 52428800) {
      $('#doc_testfile').val("");
      ngswal("Failed !", "Please upload File less than 50MB", "warning");
      return;
    } else {
      TestAssignmentComponent.file = fileInput.currentTarget.files[0];
      if (fileInput.currentTarget.files[0]) {

        var fileReader = new FileReader();
        fileReader.onload = (e: any) => {
          TestAssignmentComponent.fileBase64 = null;
          TestAssignmentComponent.fileBase64 = e.currentTarget.result;
        }
        fileReader.readAsDataURL(fileInput.currentTarget.files[0]);
      }
    }
  }
  GetDueDateValidationOnDate() {
    //
    var today = new Date();
    let date = $("#Txt_FromDate").val();
    this.minDate = today.toISOString().slice(0, 10);

    ApiMethod.getMethod("api/GetHolidayList").subscribe(
      result => {
        let aholidayList = result.aholidayList;
        let isHoliday: boolean = false;
        let message = "";

        if (aholidayList.length != 0) {
          isHoliday = aholidayList.some(x => x.Leave_Date.slice(0, 10) == date);

        }
        var newDate = new Date(date);

        // Check for Sunday (0 th day) or holiday(from holidays list)
        if (newDate.getDay() == 0 || isHoliday) {

          message = "Holiday";
          $("#Txt_FromDate").val('');

        } else { message = "Working"; }

        if (message == "Holiday") {
          ngswal("Warning !", "Its a holiday! Please select another date !", "warning");
        }
      });


  }
  TestAssign() {
    if ($('#doc_testfile').val() == "") {
      $('#doc_testfile').val("");
      ngswal("Failed !", "Please upload Test File..!", "warning");
      return false;
    }
    $("#LoadingImageReopen").show();
    //var ID = localStorage.aEID.split("|");
    var details = {
      PublisherId: localStorage.aPubID,
      ID: TestAssignmentComponent.FreelancerID,
      TaskId: TestAssignmentComponent.CategoryID,
      ArticleID: $("#ddlArticle").val(),
      ArticleTitle: $("#Txt_articleTitle").val(),
      ExpectedStartDate: $("#Txt_FromDate").val(),
      DueDate: $("#Txt_ToDate").val(),
      Notes: $("#TXT_Remarks").val(),
      PackageName: $("#doc_AllocationTestfile").val(),
      fileName: TestAssignmentComponent.file.name,
      fileSize: TestAssignmentComponent.file.size,
      fileAsBase64: TestAssignmentComponent.fileBase64,
      UpdatedBy: localStorage.aLoginID
    }

    ApiMethod.postMethod(TestAssignmentComponent.modelItem.FreelancertestallocationAPI, details).subscribe(
      response => {

        $("#LoadingImageReopen").hide();
        if (response.status) {
          $('#TestassignPopup').hide();
          FreelancerlistComponent.Testassignhide();
          ngswal({
            position: "top-end",
            type: "success",
            title: " Updated Successfully!",
            text: response.message,
            showConfirmButton: true
          });
        }

        else {
          ngswal({
            position: "top-end",
            type: "warning",
            title: " Failed !",
            text: response.message,
            showConfirmButton: true

          });
        }

      }, error => {
        ngswal("Failed !", error.error.Message, "warning");
        $("#LoadingImageReopen").hide();
      }
    );
  }
}
